const getVariationProductMinMaxPrice = (productVariationArray): any => {
    if (productVariationArray && productVariationArray.length > 0) {
        let minPrice =
            productVariationArray[0].sale_price !== ""
                ? productVariationArray[0].sale_price
                : productVariationArray[0].regular_price;
        let maxPrice = productVariationArray[0].regular_price;

        productVariationArray.forEach((variation: any) => {
            if (variation.sale_price !== "") {
                if (Number(variation.sale_price) < Number(minPrice)) {
                    minPrice = variation.sale_price;
                }
            } else {
                if (Number(variation.regular_price) < Number(minPrice)) {
                    minPrice = variation.regular_price;
                }

                if (Number(variation.regular_price) > Number(maxPrice)) {
                    maxPrice = variation.regular_price;
                }
            }
        });

        return {
            minPrice,
            maxPrice,
        };
    } else {
        return {
            minPrice: 0,
            maxPrice: 0,
        };
    }
};
export default getVariationProductMinMaxPrice;
